import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '@env/environment';

const SIDEBAR_COLLAPSED_KEY = 'sso_sidebar_collapsed';

@Component({
  selector: 'app-dashboard-sidebar',
  templateUrl: './dashboard-sidebar.component.html',
  styleUrls: ['./dashboard-sidebar.component.scss'],
})
export class DashboardSidebarComponent {
  logoPath = environment.logo;
  title = environment.title;
  readonly exactRouterLinkActiveOptions = { exact: true };

  @Input() isAdmin = false;
  @Input() isStudentManager = false;
  @Input() mobileOpen = false;

  @Output() logout = new EventEmitter<void>();
  @Output() closeMobile = new EventEmitter<void>();
  @Output() openMyAccounts = new EventEmitter<void>();
  @Output() openSupportContact = new EventEmitter<void>();

  collapsed = false;

  constructor() {
    this.collapsed = this.readCollapsed();
  }

  toggleCollapsed(): void {
    this.collapsed = !this.collapsed;
    try {
      localStorage.setItem(SIDEBAR_COLLAPSED_KEY, this.collapsed ? '1' : '0');
    } catch {
      // localStorage không khả dụng — bỏ qua, giữ trạng thái trong phiên
    }
  }

  onLogout(): void {
    this.logout.emit();
  }

  onNavClick(): void {
    this.closeMobile.emit();
  }

  onOpenMyAccounts(event: Event): void {
    event.preventDefault();
    this.openMyAccounts.emit();
    this.closeMobile.emit();
  }

  onOpenSupportContact(event: Event): void {
    event.preventDefault();
    this.openSupportContact.emit();
    this.closeMobile.emit();
  }

  private readCollapsed(): boolean {
    try {
      return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === '1';
    } catch {
      return false;
    }
  }
}
